import React from "react";
import { useTranslation } from "react-i18next";
import "./TimeRegistrationsMonthSummary.scss";

const TimeRegistrationsMonthSummary = ({
	workedLabel,
	targetLabel,
	targetCaption,
	balanceLabel,
	balanceShortRaw = 0,
}) => {
	const { t } = useTranslation();

	const balanceClass =
		balanceShortRaw > 0
			? "time-registrations-month-summary__balance--positive"
			: balanceShortRaw < 0
				? "time-registrations-month-summary__balance--negative"
				: "time-registrations-month-summary__balance--neutral";

	const caption = targetCaption || t("times.balance.objectiveHours");
	const captionShort =
		caption === t("times.balance.objectiveHours") ||
		caption === t("times.balance.plannedHoursLabel")
			? t("times.summary.targetHoursShort")
			: caption;

	return (
		<div className="time-registrations-month-summary">
			<div className="time-registrations-month-summary__bar">
				<span className="time-registrations-month-summary__title">
					{t("times.summary.monthSummary")}
				</span>

				<div className="time-registrations-month-summary__stats">
					<span className="time-registrations-month-summary__stat">
						<span className="time-registrations-month-summary__label time-registrations-month-summary__label--lg">
							{t("times.summary.registeredHours")}:{" "}
						</span>
						<span className="time-registrations-month-summary__label time-registrations-month-summary__label--sm">
							{t("times.summary.registeredHoursShort")}:{" "}
						</span>
						<strong className="time-registrations-month-summary__value">
							{workedLabel}
						</strong>
					</span>
					<span className="time-registrations-month-summary__stat">
						<span className="time-registrations-month-summary__label time-registrations-month-summary__label--lg">
							{caption}:{" "}
						</span>
						<span className="time-registrations-month-summary__label time-registrations-month-summary__label--sm">
							{captionShort}:{" "}
						</span>
						<strong className="time-registrations-month-summary__value">
							{targetLabel}
						</strong>
					</span>
					<span className="time-registrations-month-summary__stat">
						{t("times.summary.balance")}:{" "}
						<strong
							className={`time-registrations-month-summary__balance ${balanceClass}`}
						>
							{balanceLabel}
						</strong>
					</span>
				</div>
			</div>
		</div>
	);
};

export default TimeRegistrationsMonthSummary;
